import _extends from "@babel/runtime/helpers/extends";
// react-magnetic-di - temporary comment, for auto dependency injection in tests
import React, { useEffect, useMemo } from 'react';
import AtlaskitPlaceholder from '@atlaskit/react-ufo/placeholder';
import { parseExtensionId } from '@atlassian/forge-ui/utils/parseExtensionId';
import { useUIModificationsConsentStatusForApp } from '../../../../../controllers/adjustments-context/hooks/use-consent-status';
import { UIM_CONSENT_REQUIRED } from '../../../../../controllers/adjustments-context/types';
import { useExecutionContext } from '../../../../../controllers/execution-context';
import { useViewType } from '../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../../controllers/view-configuration';
import { useCustomBridgeMethods } from './use-custom-bridge-methods';
import { useIframeTimeout } from './use-iframe-timeout';
import { useScopeChecks } from './use-scope-checks';
import { useThreeLOPromptProps } from './use-three-lo-prompt-props';
import { buildExtensionData } from './utils/build-extension-data';
export var SingleAppRenderer = function SingleAppRenderer(_ref) {
  var forgeExtension = _ref.forgeExtension,
    uiModificationsConfig = _ref.uiModificationsConfig,
    ForgeAppRenderer = _ref.ForgeAppRenderer;
  var moduleScopes = forgeExtension.scopes,
    moduleId = forgeExtension.id;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    setError = _useIssueAdjustmentsA.setError;
  var viewType = useViewType();
  var executionContext = useExecutionContext();
  var extensionData = useMemo(function () {
    return buildExtensionData(executionContext);
  }, [executionContext]);
  var _parseExtensionId = parseExtensionId(moduleId),
    appId = _parseExtensionId.appId;

  // This hook can be removed and replaced with `onTimeout` from LazyIframe once
  // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
  // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
  var _useIframeTimeout = useIframeTimeout({
      forgeExtension: forgeExtension
    }),
    setLoadingComplete = _useIframeTimeout.setLoadingComplete;
  var _useCustomBridgeMetho = useCustomBridgeMethods({
      onBridgeCommunicationReceived: setLoadingComplete,
      uiModifications: uiModificationsConfig,
      moduleScopes: moduleScopes,
      appId: appId
    }),
    customBridgeMethods = _useCustomBridgeMetho.customBridgeMethods;
  var requiredScopesFound = useScopeChecks(moduleScopes);
  var currentUIModificationsConsentStatus = useUIModificationsConsentStatusForApp({
    appId: appId
  });
  useEffect(function () {
    if (!requiredScopesFound) {
      setError({
        errorCode: 'SCOPES_MISSING_ERROR_CODE'
      });
      setLoadingComplete();
      getAnalytics(viewType).cancelTTI();
    }
  }, [requiredScopesFound, setError, setLoadingComplete, viewType]);
  useEffect(function () {
    if (currentUIModificationsConsentStatus === UIM_CONSENT_REQUIRED) {
      setLoadingComplete();
      getAnalytics(viewType).cancelTTI();
    }
  }, [currentUIModificationsConsentStatus, setLoadingComplete, viewType]);
  var consentProps = useThreeLOPromptProps({
    forgeExtension: forgeExtension
  });
  if (!requiredScopesFound) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AtlaskitPlaceholder, {
    name: "single-frame-iframe",
    fallback: null,
    key: moduleId
  }, /*#__PURE__*/React.createElement(ForgeAppRenderer, _extends({
    extension: forgeExtension,
    extensionData: extensionData,
    customBridgeMethods: customBridgeMethods,
    onIframeLoad: getAnalytics(viewType).markIframeLoad,
    isIframeResizable: false,
    isIframeHidden: true
  }, consentProps)));
};